import { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loading } from "../../components/Loading";
import "./index.css";
import { MiniHeader } from "../../components/MiniHeader";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Menu } from "../../components/Menu";
import { Header } from "../../components/Header";
import { SellerDashCard } from "../../components/SellerDashCard/SellerDashCard";
import { useSeller } from "../../hooks/useSeller";
import api from "../../services/api";
import { usePluginspace } from "../../hooks/usePluginspace";
import Swal from "sweetalert2";
import { SellerQueueCard } from "../../components/SellerQueueCard";
import { useSellerQueue } from "../../hooks/useSellerQueue";
import { useSellerSession } from "../../hooks/useSellerSession";
import { useSellerQueueRealtime, SellerQueueRealtimeEvent } from "../../hooks/useSellerQueueRealtime";


/**
 * SellerQueueCardSection
 * Helper component to render queue card in dashboard
 */
const SellerQueueCardSection: FC = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const queueHook = useSellerQueue();
  const { queueEntry, isLoading: isLoadingQueue, error: errorQueue } = queueHook;
  const { enterQueue, pauseQueue, resumeQueue, leaveQueue } = queueHook;
  const sessionHook = useSellerSession();
  const { endService } = sessionHook;

  useSellerQueueRealtime();

  const handleEnterQueue = async () => {
    try {
      setIsProcessing(true);
      await enterQueue();
    } catch (error) {
      console.error("Erro ao entrar na fila:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handlePauseQueue = async () => {
    try {
      setIsProcessing(true);
      await pauseQueue();
    } catch (error) {
      console.error("Erro ao pausar:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleResumeQueue = async () => {
    try {
      setIsProcessing(true);
      await resumeQueue();
    } catch (error) {
      console.error("Erro ao retomar:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleLeaveQueue = async () => {
    if (!window.confirm("Tem certeza que deseja sair da fila?")) return;
    try {
      setIsProcessing(true);
      await leaveQueue();
    } catch (error) {
      console.error("Erro ao sair da fila:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div style={{ marginTop: "1.5em" }}>
      <SellerQueueCard
        queueEntry={queueEntry}
        isLoading={isLoadingQueue}
        error={errorQueue}
        onEnterQueue={handleEnterQueue}
        onPause={handlePauseQueue}
        onResume={handleResumeQueue}
        onLeaveQueue={handleLeaveQueue}
        isPauseLoading={isProcessing}
        isResumeLoading={isProcessing}
        isLeaveLoading={isProcessing}
      />
    </div>
  );
};

const SellerDashboard: FC = () => {
  const [loading, setLoading] = useState(false);
  const [loadingHeader, setLoadingHeader] = useState(true);
  const { getSellerAppConfig } = useAppConfig();
  const { sellerUser } = useSeller()
  const { getToken } = usePluginspace();
  const [config, setConfig] = useState<ConfigType | void>();
  const [initDate, setInitDate] = useState<string>('');
  const [finDate, setFinDate] = useState<string>('');
  const [clickQuantity, setClickQuantity] = useState<string>('0');
  const [cartQuantity, setCartQuantity] = useState<string>('0');
  const [sellValue, setSellValue] = useState<string>('0');





  async function getConfig() {
    try {
      setLoadingHeader(true);
      const config = await getSellerAppConfig()
      setConfig(config)
      setLoadingHeader(false);
    } catch (error) {
      setLoadingHeader(false);
      console.log(error)
    }
  }

  async function initalData() {
    try {
      const today = new Date();
      const todayString = today.toISOString().split('T')[0];

      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 7);
      const sevenDaysAgoString = sevenDaysAgo.toISOString().split('T')[0];


      setFinDate(todayString)
      setInitDate(sevenDaysAgoString)
    } catch (error) {
      console.log(error)
      return false
    }
  }

  // funções utilizadas na getSellerInfo

  //pegar numero de acessos via link do vendedor;
  async function getClickQuantity(initDate: string, finalDate: string) {
    try {
      const resClicksQuantity = await api.post('api/accessCount/filter',
        {
          startDate: `${initDate} 00:00:00`,
          endDate: `${finalDate} 23:59:59`,
          cpfIndicator: sellerUser?.cpf
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      ).then(res => res.data).catch(err => {
        console.log(err)
        return null
      })

      if (!resClicksQuantity || !resClicksQuantity.data) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Não foi possivel recuperar dados. Favor tentar novamente mais tarde'
        })
        return
      }
      setClickQuantity(resClicksQuantity.data.itemCount)


      return null
    } catch (error) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Não foi possivel recuperar dados. Favor tentar novamente mais tarde'
      })
      return null
    }
  }

  //pegar numero de carrinhos
  async function getCartQuantity(initDate: string, finalDate: string) {
    try {
      const resCartQuantity = await api.post('api/customerCart/qtd_order_cart',
        {
          initDate: `${initDate} 00:00:00`,
          finDate: `${finalDate} 23:59:59`,
          cpfSeller: sellerUser?.cpf
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      ).then(res => res.data).catch(err => {
        console.log(err)
        return null
      })

      if (!resCartQuantity || !resCartQuantity.data) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Não foi possivel recuperar dados. Favor tentar novamente mais tarde'
        })
        return
      }
      setCartQuantity(resCartQuantity.data.qtdcarrinhos)


      return null
    } catch (error) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Não foi possivel recuperar dados. Favor tentar novamente mais tarde'
      })
      return null
    }
  }



  //pegar Receita do Vendedor
  async function getSellValue(initDate: string, finalDate: string) {
    try {
      const resSellValue = await api.post('api/customerCart/value_order_cart',
        {
          initDate: `${initDate} 00:00:00`,
          finDate: `${finalDate} 23:59:59`,
          cpfSeller: sellerUser?.cpf
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      ).then(res => res.data).catch(err => {
        console.log(err)
        return null
      })

      if (!resSellValue || !resSellValue.data) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: 'Não foi possivel recuperar dados. Favor tentar novamente mais tarde'
        })
        return null
      }
      setSellValue(resSellValue.data.valorTotal)


      return null
    } catch (error) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Não foi possivel recuperar dados. Favor tentar novamente mais tarde'
      })
      return null
    }
  }


  async function getSellerInfo() {
    try {
      if (sellerUser) {
        setLoading(true)
        let today = new Date().toISOString().split('T')[0];
        let sevenDaysAgo = new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0];

        if (initDate && finDate) {
          today = finDate;
          sevenDaysAgo = initDate;
        }
        await Promise.all([
          getCartQuantity(sevenDaysAgo, today),
          getClickQuantity(sevenDaysAgo, today),
          getSellValue(sevenDaysAgo, today)
        ])
        setLoading(false)
      }
    } catch (error) {
      console.log(error)
      return false
    }
  }


  async function loadAllData() {
    setLoading(true)
    await getConfig();
    await Promise.all([
      initalData(),
      getSellerInfo()
    ])
    setLoading(false)
  }

  useEffect(() => {
    loadAllData()
  }, [sellerUser])

  return (
    <div className="sellerDashboardHome">
      <div className="content-dashboard">
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              (config && config?.content && config?.content.pdv && config?.content.pdv.noSales)
                ? config.content.pdv.noSales
                : false
            }
            extraSpacingLeftMenu
          />
        )}

        {loading ? (
          <div style={{ width: '100%', height: 'calc(100vh)' }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className="dashboard-values">
            <div className="headerCard">
              <h3>
                Resultados
              </h3>

              <div className="headerFindCard">
                <div className="inputs">
                  <label className="label">
                    <span>Inicio</span>
                    <input type="date" className="date" value={initDate}
                      onChange={(event) => {
                        setInitDate(event.target.value)
                      }

                      } />
                  </label>
                  <label className="label">
                    <span>Fim</span>
                    <input type="date" className="date" value={finDate}
                      onChange={(event) =>
                        setFinDate(event.target.value)
                      } />
                  </label>

                </div>
                <div className="button" onClick={getSellerInfo}>
                  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12.5312 6.24219L7.71875 10.8359C7.44531 11.082 7.03516 11.082 6.78906 10.8086C6.54297 10.5352 6.54297 10.125 6.81641 9.87891L10.4531 6.40625H1.15625C0.773438 6.40625 0.5 6.13281 0.5 5.75C0.5 5.39453 0.773438 5.09375 1.15625 5.09375H10.4531L6.81641 1.64844C6.54297 1.40234 6.54297 0.964844 6.78906 0.71875C7.03516 0.445312 7.47266 0.445312 7.71875 0.691406L12.5312 5.28516C12.668 5.42188 12.75 5.58594 12.75 5.75C12.75 5.94141 12.668 6.10547 12.5312 6.24219Z"
                      fill="white" />
                  </svg>
                </div>

              </div>
            </div>

            <div className="headerBody">
              <SellerDashCard name="Clicks" type="number" value={clickQuantity} />
              <SellerDashCard name="Pedidos" type="number" value={cartQuantity} />
              <SellerDashCard name="Vendas" type="money" value={sellValue} />
            </div>

            <SellerQueueCardSection />

          </div>
        )
        }
        {!loadingHeader && (
          <Menu
            activeMenu="category"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              (config && config?.content && config?.content.pdv && config?.content.pdv.noSales)
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
    </div>
  )
}

export { SellerDashboard }